import script from "./TabObjetivos.vue?vue&type=script&setup=true&lang=js"
export * from "./TabObjetivos.vue?vue&type=script&setup=true&lang=js"

import "./TabObjetivos.vue?vue&type=style&index=0&id=17e82300&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17e82300"]])

export default __exports__